import type { Bulle } from '../partage/api/types';
import { CasesDeLaDuree } from './CasesDeLaDuree';
import { Ligne } from './Saisies';
import { SelecteurPriorite } from './SelecteurPriorite';
import { CA_ME_PREND, CA_ME_PREND_EXPLIQUE, IMPORTANCE, IMPORTANCE_EXPLIQUEE } from '../partage/vocabulaire';
import './ReglagesDeLaFiche.css';

/**
 * Les choix de l'importance une fois dépliés, dans le panneau Réglages du téléphone (chantier
 * `nettoyage-fiche`, ticket 01). L'ordinateur les entoure dans l'intercalaire État
 * (`PanneauDesReglages`, reglages-de-la-fiche, deuxième passe de 02).
 */
export function ChoixDeLImportance({ bulle, onChanger }: { bulle: Bulle; onChanger: (champs: Partial<Bulle>) => void }) {
  return (
    <Ligne nom={IMPORTANCE} aide={IMPORTANCE_EXPLIQUEE}>
      <SelecteurPriorite valeur={bulle.prioriteChoisie} onChoisir={(prioriteChoisie) => onChanger({ prioriteChoisie })} />
    </Ligne>
  );
}

/**
 * La durée une fois dépliée, la même aux deux fiches : deux cases, heures puis minutes
 * (chantier duree-a-la-minute, ticket 03, décision d'Igor du 2026-10-11). La tâche garde le
 * total en minutes (`effortMin`) ; 0 et 0 l'enlève.
 */
export function ChoixDeLaDuree({
  bulle,
  onChanger,
  onFini,
}: {
  bulle: Bulle;
  onChanger: (champs: Partial<Bulle>) => void;
  /** Entrée dans une case : le réglage se replie (retour d'Igor du 2026-10-11). */
  onFini: () => void;
}) {
  return (
    <Ligne nom={CA_ME_PREND} aide={CA_ME_PREND_EXPLIQUE}>
      <CasesDeLaDuree effortMin={bulle.effortMin} onEcrire={(effortMin) => onChanger({ effortMin })} onFini={onFini} />
    </Ligne>
  );
}

/** Le « + » de la maquette, pour ce qui reste à poser. */
export function Plus() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
      <path d="M12 5v14M5 12h14" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}
